(function() {
  function formatMoney(cents) {
    if (window.themeVendor && window.themeVendor.themeCurrency && window.theme) {
      var formatted = window.themeVendor.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
      return window.theme.settings.currency_code_enable ? formatted + ' ' + window.theme.currencyCode : formatted;
    }

    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    var wrapper = event.target && event.target.closest('[data-section-id]');
    if (!wrapper) return;

    var installmentPrices = wrapper.querySelectorAll('[data-installment-price]');
    if (!installmentPrices.length) return;

    installmentPrices.forEach(function(element) {
      element.innerHTML = variant ? formatMoney(Math.floor(variant.price / 3)) : '&nbsp;';
    });
  });
})();
